import React, { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import './jurisdiction.css';
import { getTribunalDetail } from '../../lib/strapi/phaseThreeContent';

const Jurisdiction = () => {
    const [tribunal, setTribunal] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    const { slug, id } = useParams();

    useEffect(() => {
        let isMounted = true;

        async function loadTribunal() {
            setIsLoading(true);

            const nextTribunal = await getTribunalDetail(slug || id);

            if (isMounted) {
                setTribunal(nextTribunal);
                setIsLoading(false);
            }
        }

        loadTribunal();

        return () => {
            isMounted = false;
        };
    }, [id, slug]);

    if (isLoading) {
        return (
            <section className="jurisdiction_container">
                <h2>Loading tribunal details...</h2>
            </section>
        );
    }

    if (!tribunal) {
        return (
            <section className="jurisdiction_container">
                <h2>Tribunal details are not available yet.</h2>
                <p>Please return to the tribunals page and try another listing.</p>
            </section>
        );
    }

    const virtualCourtLinks = Array.isArray(tribunal.virtualCourtLinks)
      ? tribunal.virtualCourtLinks
      : [];

    return (
        <>
            <div className='jurisdiction_image'>
                <img src={tribunal.image} alt={tribunal.tribunalName} />
            </div>
            <section className="jurisdiction_container">
              <div className="jurisdiction_plans">
                <div className='jurisdiction_container-left_box'>
                    <h2 className='tribename'>{tribunal.tribunalName}</h2>
                    <h2 className='tribenames'>ChairPerson</h2>
                    <h3>{tribunal.chairman || "To be updated"}</h3>
                    <h2 className='tribenamess'>Current Members</h2>
                    {tribunal.members.map((memberName, index) => (
                        <ul className="list_members" key={`${memberName}-${index}`}>
                            <li className='list_member'>{memberName}</li>
                        </ul>
                    ))}
                    {(virtualCourtLinks.length > 0 || tribunal.virtualCourtLink) && (
                      <>
                        <h2>Permanent Tribunal Virtual Court Links</h2>
                        {virtualCourtLinks.length > 0 ? (
                          <div className="virtual-court-links">
                            {virtualCourtLinks.map((item, index) => (
                              <div className="virtual-court-link-item" key={`${item.url}-${index}`}>
                                <h3>{item.label}</h3>
                                <a
                                  className="virtual-court-link"
                                  href={item.url}
                                  target="_blank"
                                  rel="noreferrer"
                                >
                                  {item.url}
                                </a>
                              </div>
                            ))}
                          </div>
                        ) : (
                          <a
                            className="virtual-court-link"
                            href={tribunal.virtualCourtLink}
                            target="_blank"
                            rel="noreferrer"
                          >
                            {tribunal.virtualCourtLink}
                          </a>
                        )}
                      </>
                    )}
                    <h2>Contact</h2>
                    <h3>{tribunal.email || "To be updated"}</h3>
                </div>
                <div className="jurisdiction_container-right_box">
                    <h1>Establishment</h1>
                    <h3>{tribunal.description}</h3>
                    <h2>Number of Members of the Tribunal</h2>
                    <h3>{tribunal.membersNo || "To be updated"}</h3>
                    <h2>Jurisdiction</h2>
                    {tribunal.jurisdiction.map((jurisdictionName, index) => (
                        <ul key={`${jurisdictionName}-${index}`}>
                            <li>- {jurisdictionName}</li>
                        </ul>
                    ))}
                    {tribunal.qrcode && (
                      <>
                        <h2>Scan to see Judgements</h2>
                        <img className="qrcode" src={tribunal.qrcode} alt="QR Code for Judgements" />
                      </>
                    )}
                    {tribunal.judgmentsUrl && (
                      <a
                        className='button-link'
                        href={tribunal.judgmentsUrl}
                        target="_blank"
                        rel="noreferrer"
                      >
                        View Judgments
                      </a>
                    )}
                    <h2>Location</h2>
                    <h3>{tribunal.location || "To be updated"}</h3>
                    <button className='efiling'>
                        <Link to={tribunal.filingUrl} target="_blank" rel="noreferrer">E-Filing</Link>
                    </button>
                </div>
              </div>
            </section>
        </>
    );
}

export default Jurisdiction;
